import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonGrid,
  IonLabel,
  IonList,
  IonRow,
  IonToolbar,
} from '@ionic/react'
import React from 'react'
import SingleSelect from '../../../../../components/singleSelect/SingleSelect.component'
import { useDispatch, useSelector } from 'react-redux'
import { getNeuroOptionsSelector } from '../../../../options/selectors'
import { INeuroOptionsState } from '../../../../options/store/options.types'
import { getNeuroSelector } from '../../selectors'
import { INeuroState } from '../../store/neuro.types'
import { saveNeuro, setStrokeScaleId, setStrokeScaleScore } from '../../store/neuro.actions'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../../../components/tabs/Tabs.constants'
import { useTranslation } from 'react-i18next'
import './StrokeScore.content.css'

const StrokeScoreContent: React.FC = () => {
  const neuroOptionState: INeuroOptionsState = useSelector(getNeuroOptionsSelector)
  const { customStrokeScaleScoreOptions } = neuroOptionState

  const neuroState: INeuroState = useSelector(getNeuroSelector)
  const { neuroPrStrokeScale, strokescaleScore } = neuroState

  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation()

  const handleStrokeScaleOnChange = (quesId: string, selectedOption: any) => {
    const updatedSelectedOption = { ...selectedOption, quesId }
    const strokeData: any = [...neuroPrStrokeScale]
    let score = strokescaleScore || 0
    const findIndexEle = strokeData.findIndex((strokeDataObj: any) => strokeDataObj.quesId === quesId)
    if (findIndexEle >= 0 && selectedOption) {
      score = score - strokeData[findIndexEle].fieldNumeric + selectedOption.fieldNumeric
      strokeData[findIndexEle] = updatedSelectedOption
    } else if (findIndexEle >= 0 && !selectedOption) {
      score = score - strokeData[findIndexEle].fieldNumeric
      strokeData.splice(findIndexEle, 1)
    } else {
      strokeData.push(updatedSelectedOption)
      score = score + selectedOption.fieldNumeric
    }
    dispatch(setStrokeScaleId(strokeData))
    dispatch(setStrokeScaleScore(score))
    dispatch(saveNeuro())
  }

  const resetStrokeScoreData = () => {
    dispatch(setStrokeScaleId([]))
    dispatch(setStrokeScaleScore(null))
    dispatch(saveNeuro())
  }

  return (
    <>
      <IonContent className='ion-margin-bottom' fullscreen>
        <IonList>
          <IonGrid>
            <IonRow className='ion-margin'>
              <IonLabel>Total Score </IonLabel>
              {strokescaleScore != null && <IonLabel className='custom-number-label'> {strokescaleScore}</IonLabel>}
            </IonRow>
            {customStrokeScaleScoreOptions.length > 0 && (
              <>
                {customStrokeScaleScoreOptions.map((strokeScaleOptions: any) => {
                  const { question, quesId, answerOptions } = strokeScaleOptions
                  const selectedOption = neuroPrStrokeScale.length
                    ? neuroPrStrokeScale.find((strokeDataObj: any) => strokeDataObj.quesId === quesId)
                    : {}
                  return (
                    <React.Fragment key={quesId}>
                      <SingleSelect
                        dataTestID={question}
                        options={answerOptions}
                        selectedOption={selectedOption}
                        listHeader={question}
                        label={question}
                        action={(e) => {
                          handleStrokeScaleOnChange(quesId, e)
                        }}
                        showSelectedOptionId={'fieldNumeric'}
                      />
                      <hr className='field-divider' />
                    </React.Fragment>
                  )
                })}
              </>
            )}
          </IonGrid>
        </IonList>
      </IonContent>
      <IonFooter>
        <IonToolbar color='light' className='p-10'>
          <IonButtons className='btn-grps'>
            <IonButton
              className='btn btn-tablet'
              color='danger'
              fill='outline'
              expand='block'
              onClick={resetStrokeScoreData}>
              {t('common.buttons.Clear')}
            </IonButton>
            <IonButton
              className='btn btn-tablet btn-primary'
              expand='block'
              onClick={() => {
                history.push(TabConstants.INITIAL_ASSESSMENT)
              }}>
              {t('common.buttons.Save')}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonFooter>
    </>
  )
}

export default StrokeScoreContent
